<template>
	<div>
		<header class="page-title">
			<h2>Properties Editor</h2>
		</header>
		<list-renderer :id="'summarySettingsLister'" :apiUrl="'/api/' + $selectedSite.slug + '/providers/properties/lister'" :filterIn="filterIn" :listInData="'properties'" :listType="'general'" :orderBy="orderBy" :orderByRules="orderByRules" :showOnly="showOnly" :limit="'25'" :additionalFilters="additionalFilters">
			<template #header="{title}">
			</template>
			<template #content='{list}'>
				<div class="table-lister table-responsive">
					<table class="comments">
						<thead>
							<tr>
								<th>Provider Type</th>
								<th>Name</th>
								<th>Type</th>
								<th>Languages</th>
								<th>Actions</th>
							</tr>
						</thead>
						<tbody>
							<tr v-for="item in list">
								<td>{{ item.provider_type }}</td>
								<td>{{ item.defaultName }}</td>
								<td>{{ item.type }}</td>
								<td class="nowrap">
									<ul class="translation-languages">
										<li :class="[checkTranslation(item,language) === true ? 'badge-success' : 'badge-danger']"
											:title="[checkTranslation(item,language) === true ? 'Translation in place' : 'Missing translation']"
											class="badge"
											v-for="language in availableLanguages"
											v-if="!selectedAdditionalFilters.hasOwnProperty('languages') || selectedAdditionalFilters.hasOwnProperty('languages') && selectedAdditionalFilters.languages === language.locale"
										>
											{{ language.locale }}
										</li>
									</ul>
								</td>

								<td class="nowrap">
									<a @click="editProperty(item)" class="btn btn-icon btn-primary" title="Edit" v-show="userRoles.includes('site_content.update')"><i class="fas fa-fw fa-pencil-alt"></i></a>
									<a @click="deleteProperty(item)" class="btn btn-icon btn-danger" title="Delete" v-show="userRoles.includes('site_content.delete') && !userRoles.includes('users.translator')"><i class="fas fa-fw fa-trash"></i></a>
								</td>
							</tr>
						</tbody>
					</table>
				</div>
			</template>
		</list-renderer>

		<div class="modal-bg" v-if="translationModal && selectedProperty.id !== null">
			<div class="modal">
				<header class="modal-header">
					<h4 class="modal-title">Edit Translations</h4>
					<a class="modal-close" title="Close modal" @click.prevent="closeTranslationModal"><i class="fas fa-times"></i></a>
				</header>
				<section class="modal-body">
					<div class="card mb-0">
						<header class="card-header language-list">
							<lang-selector></lang-selector>
						</header>
						<div class="card-body">
							<div class="form-group">
								<label for="name">Name</label>
								<input id="name" type="text" v-model="selectedProperty[clickedLang].name">
							</div>
							<div class="form-group">
								<label for="description">Description</label>
								<textarea id="description" type="text" v-model="selectedProperty[clickedLang].description"></textarea>
							</div>
						</div>
					</div>
				</section>
				<footer class="modal-footer">
					<a class="btn btn-md btn-success" @click="saveProperty"><i class="fas fa-check"></i> Save</a>
				</footer>
			</div>
		</div>
	</div>
</template>

<script>
import {eventBus} from "../../app";
import modal from "../Modal/DefaultModal.vue";
import VueSelect from '../../../../node_modules/vue-select';
import Errors from '../../Utils/Errors.js';

export default {
	components: {
		modal,
		VueSelect
	},
	props: {
		dataShowOnly: {
			type: Object
		},
		dataEndpoint: {
			type: String
		},
		dataUrlParams: {
			type: Object,
			required: false
		},
		dataSelectedSite: {
			type: Object
		}
	},

	data() {
		return {
			userRoles: this.$currentUserRoles,
			filterIn: ['provider_type', 'defaultName'],
			orderBy: ['provider_type', 'defaultName'],
			orderByRules: ['asc', 'asc'],
			showOnly: typeof this.dataShowOnly !== 'undefined' && Object.keys(this.dataShowOnly) > 0 ? this.dataShowOnly : {},
			timestamp: Math.floor(Date.now() / 1000),
			additionalFilters: {
				languages: {
					elements: this.$availableLanguages,
					elementsValue: 'locale',
					elementsLabel: 'title',
					width: 2,
					filterIn: null,
					default: null,
					orderBy: ['title'],
					orderByRules: ['asc'],
				}
			},
			selectedAdditionalFilters: {},

			availableLanguages: this.$availableLanguages,
			isEditModalVisible: false,
			clickedLang: this.$defaultLanguage.locale,

			groups: [],
			translationList: [],

			translationModal: false,
			selectedProperty: {
				id: null
			},

			errors: new Errors(),
		}
	},

	created() {
		let vm = this;

		eventBus.$on('setActiveStatus', function (clickedLang) {
			vm.clickedLang = clickedLang;
		});

		eventBus.$on('listRendererData', function (data) {
			vm.processListRendererData(data);
		});

		eventBus.$on('additionalFilterChange', function (name, filter, value) {
			vm.additionalFilterChange(name, filter, value);
		});

	},

	methods: {
		additionalFilterChange(name, filter, value) {
			if (value === null) {
				Vue.delete(this.selectedAdditionalFilters, name);
			} else {
				this.selectedAdditionalFilters[name] = value;
			}
		},
		processListRendererData: function (data) {
			if (data.hasOwnProperty('groups')) {
				this.groups = data.groups;
			}
		},
		editProperty: function (property) {
			this.selectedProperty = property;

			let vm = this;
			Object.keys(this.availableLanguages).forEach(function (index) {
				if (!vm.selectedProperty.hasOwnProperty(vm.availableLanguages[index].locale)) {
					vm.selectedProperty[vm.$availableLanguages[index].locale] = {};
				}
			});
			eventBus.$emit('pushActiveStatus', this.$defaultLanguage);
			this.clickedLang = this.$defaultLanguage.locale;
			this.translationModal = true;
		},
		saveProperty: function () {
			let vm = this;
			axios.post('/api/' + vm.$selectedSite.slug + '/providers/properties/update', vm.selectedProperty)
					.then(response => {
						this.$toastr.success('New translation saved.');
						vm.closeTranslationModal();
					})
					.catch(e => {
						this.errors.record(e.response.data);
						this.$toastr.error('Save new translation failed.', 'Error');
					});
		},
		closeTranslationModal: function () {
			let options = {
				keepPage: true
			}
			eventBus.$emit('listRenderer-fetch', options);
			this.translationModal = false;
			this.clickedLang = this.$defaultLanguage.locale;
		},
		deleteProperty: function (property) {
			let vm = this;

			axios.delete('/api/' + vm.$selectedSite.slug + '/provider-types/' + property.provider_type_id + '/groups/' + property.group.id + '/properties/' + property.id)
					.then(response => {
						this.$toastr.success('Property deleted successfully.');
						let options = {
							keepPage: true
						}
						eventBus.$emit('listRenderer-fetch', options);
					})
					.catch(e => {
						this.errors.record(e.response.data);
						this.$toastr.error('Property delete failed.', 'Error');
					});
		},
		checkTranslation(item, language) {
			let locale = language.locale
			return item.hasOwnProperty(locale) && item[locale] !== null && typeof item[locale] !== 'undefined' && item[locale].hasOwnProperty('name') && typeof item[locale].name !== 'undefined' && item[locale].name !== null && item[locale].name !== 'null' && item[locale].name !== '';
		}
	}
}
</script>

<style>
.important.translation {
	color: #E6393;
}
</style>
